export default __webpack_public_path__ + "static/media/golden_cat.6cbc42d5.png";